import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
              Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It combines creative design and technical mastery in Blender with an ethical, community-centered approach, empowering youth to turn imagination into impactful 3D projects. </p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Skills & Tools You’ll Gain'}
                  text={'Perfect for individuals seeking new skills or enhancing their portfolio'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Proficiency in Blender, a leading 3D creation suite.'}
                  text2={'Experience in 3D modeling, animation, and rigging for games, apps, and films.'}
                  text3={'Ability to design interactive 3D content for websites, advertising, and visual storytelling.'}
                  text4={'Knowledge of simulation systems (fluids, particles, smoke, soft bodies).'}
                  text5={'Skills in creating graphical environments for technical fields like architecture, engineering, and simulations.'}           
                  text6={'A strong portfolio of 3D models, animations, and visual effects to showcase creativity and technical expertise.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
